import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getServerTime, listPaySegments, recalculatePaySegment, setServerTime } from './api';
import { RecalculatePaySegmentRequest } from './types';

const PAY_SEGMENTS_KEY = ['admin-pay-segments'] as const;
const SERVER_TIME_KEY = ['admin-server-time'] as const;

export function usePaySegments(page: number, perPage: number, userID?: string) {
  return useQuery({
    queryKey: [...PAY_SEGMENTS_KEY, page, perPage, userID],
    queryFn: () => listPaySegments(page, perPage, userID),
    placeholderData: keepPreviousData,
  });
}

export function useServerTime() {
  return useQuery({ queryKey: SERVER_TIME_KEY, queryFn: getServerTime });
}

export function useSetServerTime() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: setServerTime,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: SERVER_TIME_KEY });
      client.invalidateQueries({ queryKey: PAY_SEGMENTS_KEY });
    },
  });
}

export function useRecalculatePaySegment() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: RecalculatePaySegmentRequest) => recalculatePaySegment(input),
    onSuccess: () => client.invalidateQueries({ queryKey: PAY_SEGMENTS_KEY }),
  });
}
